class ProductBrewRecipes extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.tabs = Array.from(this.querySelectorAll('[data-recipe-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-recipe-panel]'));
    this.accordionPanel = this.querySelector('[data-recipe-accordion-panel]');

    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-recipe-tab]');
      if (tab && this.contains(tab)) this.selectTab(tab);
    });

    this.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-recipe-tab]');
      if (!tab || !this.contains(tab)) return;

      const currentIndex = this.tabs.indexOf(tab);
      let nextIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      }
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === undefined) return;

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.selectTab(this.tabs[nextIndex]);
    });
  }

  selectTab(activeTab) {
    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
    });

    requestAnimationFrame(() => this.updateAccordionHeight());
  }

  updateAccordionHeight() {
    if (!this.accordionPanel || this.accordionPanel.getAttribute('aria-hidden') === 'true') return;
    this.accordionPanel.style.height = `${this.accordionPanel.scrollHeight}px`;
  }
}

if (!customElements.get('product-brew-recipes')) {
  customElements.define('product-brew-recipes', ProductBrewRecipes);
}
